const JourneyStepsStatus = {
  UNSEEN: 'unseen',
  VISITED: 'visited',
  APPROVED: 'approved',
  ERROR: 'error',
};

export default JourneyStepsStatus;
